import React from 'react';
import Link from 'gatsby-link';
import styles from './Menu.module.css';

class Menu extends React.Component {
  render() {
    return (
      <div className={styles.menu}>
        <Link to='/'>Home</Link>|
        <Link to='/our-adventures'>Our adventures</Link>|
        <Link to='/weird-about-us'>WeirdAboutUS</Link>|
        <Link to='/my-work'>My work</Link>
      </div>
    );
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js